import { createStyles, makeStyles } from '@mui/styles';

const usePresetItemStyles = makeStyles(({ spacing, palette }) => {
  return createStyles({
    presetItemText: {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      width: spacing(27),
      fontSize: '0.9rem',
    },
    presetFieldDialog: {
      marginTop: spacing(2),
    },
    systemIconWrapper: {
      paddingRight: spacing(3),
      paddingBottom: spacing(0.7),
    },
    systemIcon: {
      backgroundColor: palette.common.white,
      borderRadius: '50%',
      fontWeight: 'bolder',
      width: spacing(3),
      height: spacing(3),
      paddingBottom: spacing(),
    },
    systemIconRoot: {
      fontSize: '1rem',
    },
    hiddenDiv: {
      visibility: 'hidden',
    },
    presetItemWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'left',
      '&:hover': {
        backgroundColor: 'rgba(175, 175, 175, 0.5)',
      },
    },
    editPresetItemRoot: {
      height: spacing(3),
      padding: 0,
      fontSize: '0.7rem',
    },
    editText: {
      backgroundColor: palette.common.white,
      color: palette.common.black,
      padding: spacing(),
    },
    presetItemRoot: {
      padding: 0,
      paddingLeft: spacing(2),
      height: spacing(6),
    },
    selectedPresetItem: {
      backgroundColor: 'rgba(175, 175, 175, 0.5)',
    },
    selectedPresetIcon: {
      color: palette.common.white,
      paddingLeft: spacing(4),
    },
    wideSelectedPresetIcon: {
      paddingLeft: spacing(10.2),
    },
  });
});

export default usePresetItemStyles;
